import { useCallback, useEffect, useState } from "react";
import { Breadcrumb, Button, Card, Tabs } from "antd";
import { useNavigate } from "react-router";
import OwnAccountList from "./own-account-list";
import InternationalPayeeList from "../beneficiary/international/international-payee-list";
import { AiOutlineLeft } from "react-icons/ai";
import InternalBeneList from "./internal-bene-list";
import DomesticBeneList from "./domestic-bene-list";
import FavouriteBeneList from "./favourite-bene-list";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";
import { ReactComponent as TitleIcon } from "../../assests/images/transfer.svg";
import AccountCard from "../../components/account-card";
import { ReactComponent as BeneTransferIcon } from "../../assests/images/beneTransfer.svg";
import { ReactComponent as ManageBeneIcon } from "../../assests/images/manageBenfeciary.svg";
import { ReactComponent as ScheduleTransIcon } from "../../assests/images/scheduledTransfer.svg";
import { ReactComponent as BulkUploadIcon } from "../../assests/images/bulkPayment.svg";
import { ReactComponent as SalaryUploadIcon } from "../../assests/images/salaryUploadTrans.svg";
import { ReactComponent as FileUploadIcon } from "../../assests/images/fileUploadtrans.svg";
import { ReactComponent as WithdrawIcon } from "../../assests/images/withdraw.svg";
import { ReactComponent as AddIcon } from "../../assests/images/Add.svg";
import { ReactComponent as QuickIcon } from "../../assests/images/QuickTransfer.svg";
import { ReactComponent as HistoryIcon } from "../../assests/images/Download.svg";
import { profileDetailsSelector } from "../../store/selectors/app.selector";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ProfileService from "../../services/profile.service";
import FEATURE_CONFIG from "client/feature.config.json";

export default function Transfer() {
  const navigate = useNavigate();
  const profileDetails = useSelector(profileDetailsSelector);
  const { t } = useTranslation();
  const [enableMenus, setEnableMenus] = useState({
    BENEFTI: false,
    FTI: false,
    BULKFTI: false,
    BULKUPLOADI: false,
    FILEUPLOADI: false,
    TRANSACTION_HISTORY: true,
    VIEW_SCHEDULED: true,
    CARDLESSCASHV: false,
  });

  useEffect(() => {
    getMenuPermissionDetails();
  }, []);

  const getMenuPermissionDetails = useCallback(async () => {
    try {
      const response = await ProfileService.getMenuPermissionDetails(
        "BULKFTI,FTI,BENEFTI,BULKUPLOADI,FILEUPLOADI,CARDLESSCASHV"
      );
      if (response.status === 200) {
        let enableMenusCopy = { ...enableMenus };
        response.data.forEach((element) => {
          enableMenusCopy = {
            ...enableMenusCopy,
            [element.screenCode]: element.enable,
          };
        });
        setEnableMenus(enableMenusCopy);
        console.log({ ...enableMenusCopy });
      }
    } catch (error) {}
  }, [enableMenus]);

  return (
    <>
        {/* <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {" "}
              {t("navigation.transfer", {
                defaultValue: "Transfers",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb> */}

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {" "}
              {t("navigation.transfer", {
                defaultValue: "Transfers",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
          <Card className="application-card"  >
            <AccountCard />
          </Card>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card ">
            <div className="row">
              {enableMenus.BENEFTI && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/add-beneficary")}
                  >
                    <div className="my-3">
                      <AddIcon height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("pages.Add_Bene.title", {
                          defaultValue: "Add Beneficiary",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.sendMoney.payee.add_bene_details", {
                          defaultValue: "Add your Beneficiary Details",
                        })}
                      </span>
                    </div>
                  </Card>
                </div>
              )}

              {enableMenus.FTI && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/send-money/quick-pay")}
                  >
                    <div className="my-3">
                      <QuickIcon height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("pages.sendMoney.payee.quick_transfer", {
                          defaultValue: "Quick Transfer",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.sendMoney.payee.make_quick_transfer", {
                          defaultValue: "Make Quick Funds Transfer",
                        })}
                      </span>
                    </div>
                  </Card>
                </div>
              )}

              {enableMenus.FTI && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/send-money")}
                  >
                    <div className="my-3">
                      <BeneTransferIcon height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("navigation.bene_transfer", {
                          defaultValue: "Beneficiary Transfer",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.sendMoney.payee.send_money_to_bene", {
                          defaultValue: "Send money To Your Beneficiaries",
                        })}{" "}
                      </span>
                    </div>
                  </Card>
                </div>
              )}

              {enableMenus.BENEFTI && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/send-money/manage-beneficiary")}
                  >
                    <div className="my-3">
                      <ManageBeneIcon height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("pages.Add_Bene.manage_beneficiaries", {
                          defaultValue: "Manage Beneficiaries",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.sendMoney.payee.manage_your_bene", {
                          defaultValue: "Manage Your Beneficiaries",
                        })}{" "}
                      </span>
                    </div>
                  </Card>
                </div>
              )}

              {enableMenus.TRANSACTION_HISTORY && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/send-money/history")}
                  >
                    <div className="my-3">
                      <HistoryIcon height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("pages.fundtransfer.transaction_history", {
                          defaultValue: "Transaction History",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.pay_bills.download_your_receipts", {
                          defaultValue: "Download your Receipts",
                        })}
                      </span>
                    </div>
                  </Card>
                </div>
              )}

              {enableMenus.VIEW_SCHEDULED && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/send-money/scheduled")}
                  >
                    <div className="my-3">
                      <ScheduleTransIcon height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("buttons.view_scheduled_transactions_btn", {
                          defaultValue: "View Scheduled Transactions",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.sendMoney.payee.manage_scheduled_transfers", {
                          defaultValue: "Manage scheduled Transfers",
                        })}{" "}
                      </span>
                    </div>
                  </Card>
                </div>
              )}

              {/* {enableMenus.FILEUPLOADI && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/salary-upload")}
                  >
                    <div className="my-3">
                      <SalaryUploadIcon height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("navigation.salary_upload", {
                          defaultValue: "Salary Upload",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.sendMoney.payee.upload_salaries", {
                          defaultValue: "Upload Salaries",
                        })}{" "}
                      </span>
                    </div>
                  </Card>
                </div>
              )} */}

              {/* {enableMenus.BULKUPLOADI && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/bulk-payment-upload")}
                  >
                    <div className="my-3">
                      <FileUploadIcon height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("navigation.bulk_upload", {
                          defaultValue: "Bulk Payment Upload",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.sendMoney.payee.upload_bulk_payments", {
                          defaultValue: "Upload Bulk payments",
                        })}{" "}
                      </span>
                    </div>
                  </Card>
                </div>
              )} */}

              {/* {enableMenus.BULKFTI && (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <Card
                    className="settingscard mb-3 "
                    align="center"
                    onClick={() => navigate("/bulk-payment")}
                  >
                    <div className="my-3">
                      <BulkUploadIcon height={40} />
                    </div>
                    <div className="my-2">
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {t("navigation.bulk_payment", {
                          defaultValue: "Bulk Payment",
                        })}
                      </span>
                    </div>
                    <div>
                      <span
                        className="secondary_txt_color_two"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {t("pages.sendMoney.payee.user_can_do_bulk_transfers", {
                          defaultValue: "User can do Bulk Transfers",
                        })}{" "}
                      </span>
                    </div>
                  </Card>
                </div>
              )} */}

              {enableMenus.CARDLESSCASHV &&
                FEATURE_CONFIG.DASHBOARD.WITHDRAW && (
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                    <Card
                      className="settingscard mb-3 "
                      align="center"
                      onClick={() => navigate("/cardless-cash")}
                    >
                      <div className="my-3">
                        <WithdrawIcon height={30} />
                      </div>
                      <div className="my-2">
                        <span
                          className="secondary_txt_color_two"
                          style={{
                            fontSize: "14px",
                            fontWeight: 600,
                          }}
                        >
                          {t("navigation.Withdraw", {
                            defaultValue: "Withdraw",
                          })}
                        </span>
                      </div>
                      <div>
                        <span
                          className="secondary_txt_color_two"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          {t("pages.sendMoney.payee.user_can_withdraw", {
                            defaultValue: "User can Withdraw Cash",
                          })}{" "}
                        </span>
                      </div>
                    </Card>
                  </div>
                )}
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
